import { render, staticRenderFns } from "./CreateShippingServiceProviderComponent.vue?vue&type=template&id=00ec2e46&"
import script from "./CreateShippingServiceProviderComponent.vue?vue&type=script&lang=js&"
export * from "./CreateShippingServiceProviderComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports